import {defaultProperties} from "../Object/Types";

export const filterMenuTypes = (component) =>
    (defaultProperties[component].name !== "Group") &&
    (defaultProperties[component].name !== "Rectangle") && (defaultProperties[component].name !== "Text")
